import Glide from "@glidejs/glide";

/*const miniContentSliderConfiguration = {
    type: "slider",
    perView: ,
    gap: 25,
    peek: {
        before: 0,
        after: 200,
    },
    bound: true,
    breakpoints: {
        767: {
            perView: 1,
            peek: {
                before: 0,
                after: 60,
            },
            gap: 10,
        },
        1280: {
            perView: 2,
            peek: {
                before: 0,
                after: 200,
            },
            gap: 10,
        },
    },
};*/

document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelectorAll(".mini-content-slider")
        .forEach(function (contentSlider, idx) {
            let this_slider = new Glide(contentSlider, {
                type: "slider",
                rewind: false,
            }).mount();
        });
});
